import { Button, Stack, styled, Typography } from '@mui/material';

import { IInventoryLocation } from '@/models/inventory.locations';
import { colors } from '@/theme/variables';

const LinkedInventoryLocationItemRoot = styled(Stack)(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 54,
  margin: '8px 0 16px',
  border: `1px solid ${colors.grey[20]}`,
  borderRadius: 6,

  '& .content': {
    flex: 1,
    flexDirection: 'row',
    marginLeft: 15,
  },

  '& .txt-name': {
    flex: 1,
    marginRight: 10,
  },
  '& .txt-type': {
    flex: 1,
    marginRight: 20,
  },
}));

export interface LinkedInventoryLocationItemProps {
  item?: IInventoryLocation;
  onRemove: () => void;
}

export const LinkedInventoryLocationItem = (
  props: LinkedInventoryLocationItemProps,
) => {
  const { item, onRemove } = props;

  return (
    <LinkedInventoryLocationItemRoot>
      <Stack className="content">
        <Typography variant="body2" className="txt-name">
          {item?.name}
        </Typography>
        <Typography variant="body2" className="txt-type">
          {item?.type?.name}
        </Typography>
      </Stack>
      <Button variant="text" color="error" onClick={onRemove}>
        Remove
      </Button>
    </LinkedInventoryLocationItemRoot>
  );
};
